import { Theme, Typography } from '@mui/material';
import { FC } from 'react';
import { IoMdArrowForward } from 'react-icons/io';
import { makeStyles } from 'tss-react/mui';

const TooltipContent: FC<TooltipContentProps> = ({
  severityName,
  start,
  end,
  color,
}) => {
  const { classes } = useStyles();
  return (
    <div className={classes.tooltipContent}>
      <div className={classes.header}>
        <span className={classes.bullet} style={{ backgroundColor: color }} />
        <Typography variant='body1' color='text.primary' component='span'>
          {severityName}
        </Typography>
      </div>
      <div className={classes.content}>
        <div>
          <Typography variant='body2' color='text.secondary'>
            Original
          </Typography>
          <Typography
            variant='body2'
            color='text.primary'
            fontWeight={600}
            className={classes.counter}>
            {start.toLocaleString()}
          </Typography>
        </div>

        <IoMdArrowForward className={classes.arrowIcon} />

        <div>
          <Typography variant='body2' color='text.secondary'>
            Ox Prioritization
          </Typography>
          <Typography
            variant='body2'
            color='text.primary'
            fontWeight={600}
            className={classes.counter}>
            {end.toLocaleString()}
          </Typography>
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  tooltipContent: {
    padding: theme.spacing(1),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  content: {
    marginBlockStart: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
  bullet: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    display: 'inline-block',
  },
  counter: {
    marginBlockStart: theme.spacing(1),
  },
  arrowIcon: {
    fontSize: '1.5rem',
    color: theme.palette.text.secondary,
  },
}));

export interface TooltipContentProps {
  severityName: string;
  start: number;
  end: number;
  color: string;
}

export default TooltipContent;
